import $ from 'jquery';

class Products {
	constructor() {
		this.$section = $('.products');
		this.$tabs = $('.products_tab');
		this.$tabsContainer = $('.products_tabs');
		this.$categories = $('.products_category');
		this.$pointer = $('.products_pointer');
		this.$pointerContainer = $('.products_pointer_container');
	}

	init() {
		this.$tabs.on('click', (e) => this.switchTab($(e.currentTarget)));

		// 初期表示のポインタ位置と色を設定
		const $activeTab = this.$tabs.filter('.is-active');
		const $activeCategory = this.$categories.filter('.is-active');
		const bgColor = $activeCategory.data('bg');
		this.updatePointer($activeTab, bgColor);

		// URLパラメータからタブを取得して初期表示
		this.checkUrlParams();

		// カスタムイベントリスナー（ナビゲーションからのタブ切り替え）
		window.addEventListener('switchProductTab', (e) => {
			const tab = e.detail.tab;
			this.switchTabByName(tab);
		});
	}

	checkUrlParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const tab = urlParams.get('tab');

		if (tab) {
			this.switchTabByName(tab, false); // スクロールなし
		}
	}

	switchTabByName(tabName, shouldScroll = true) {
		const $tab = this.$tabs.filter(`[data-category="${tabName}"]`);
		if ($tab.length > 0 && !$tab.hasClass('is-active')) {
			this.switchTab($tab, shouldScroll);
		}
	}

	switchTab($tab, shouldScroll = true) {
		if ($tab.hasClass('is-active')) return;

		const category = $tab.data('category');
		const $target = $(`#products-${category}`);
		const bgColor = $target.data('bg');

		// 現在のコンテンツをフェードアウト
		const $current = this.$categories.filter('.is-active');
		$current.fadeOut(300, () => {
			$current.removeClass('is-active');

			// 新しいコンテンツをフェードイン
			$target.fadeIn(300).addClass('is-active');
		});

		// タブの状態更新
		this.$tabs.removeClass('is-active');
		$tab.addClass('is-active');

		// ポインタの色と位置を更新
		this.updatePointer($tab, bgColor);

		// セクション上部にスクロール（オプション）
		if (shouldScroll) {
			this.scrollToTop();
		}
	}

	updatePointer($tab, bgColor) {
		bgColor === '#E1F1D8'
			? this.$pointer.addClass('is-medicated').removeClass('is-color')
			: this.$pointer.addClass('is-color').removeClass('is-medicated');
	}

	scrollToTop() {
		const headerHeight = $('.header').outerHeight() || 0;
		const offset = 20;

		$('html, body').animate(
			{
				scrollTop: this.$tabsContainer.offset().top - headerHeight - offset
			},
			500
		);
	}
}

$(() => {
	const products = new Products();
	products.init();
});

export default Products;
